import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@bd/bdcore-named-routes';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import CoreMap from '@bd/bdui-coremap';
import { colors } from '../../styles';

const styles = css`
  margin: 0 0 90px 0;
  .Detail_communityList {
    list-style: none;
    padding: 20px;
    margin: 0 0 15px 0;
    background-color: ${colors.whiteDark};
    min-height: 100%;
    @media (min-width: 992px) {
      padding: 40px;
    }
  }
  .Detail_communityListItem {
    text-align: left;
    font-size: 16px;
    line-height: 1.3;
    vertical-align: top;
    font-weight: 700;
    margin: 0 0 10px 0;
    a {
      color: ${colors.color2};
      font-weight: 700;
    }
    span {
      font-weight: 400;
      font-size: 14px;
      color: ${colors.color5};
    }
  }
`;

const communityMap = css`
  position: absolute;
  height: 400px;
  width: 100%;
  z-index: 0;
  top: 0;
  background-color: ${colors.whiteDark};
  @media (min-width: 992px) {
    position: relative;
    width: auto;
    flex-grow: 1;
    top: auto;
  }
  .leaflet-container {
    width: 100%;
    height: 100%;
  }
  .leaflet-popup-content-wrapper {
    .CommunityCard_wrapper {
      width: 100% !important;
    }
    .CommunityCard_inner {
      flex-direction: column !important;
    }
    .CommunityCard_mapButton {
      display: none !important;
    }
    .CommunityCard_detailButton {
      width: 100% !important;
    }
    .CommunityCard_buttonWrapper {
      margin: 0 !important;
    }
    .CommunityCard_priceValue {
      padding: 10px 8px !important;
    }
  }
`;

const PlanCommunitiesMap = ({ communities, activeMapPin }) => {
  return (
    <div className={styles}>
      <div className="container">
        <div className="row pb-lg-5">
          <div className="col-lg-5 pr-lg-0 mb-5 mb-lg-0">
            <ul className="Detail_communityList">
              {
                communities.map(community => (
                  <li key={community._id} className="Detail_communityListItem">
                    <Link name="community-detail" community={community}>
                      {get(community, 'name')} {' '}
                      <span>{get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')}</span>
                    </Link>
                  </li>
                ))
              }
            </ul>
          </div>
          <div className="col-lg-7 pl-lg-0">
            <CoreMap
              animate
              useFlyTo
              boundsOptions={{ animate: true, duration: 0.5 }}
              activePin={activeMapPin}
              className={communityMap}
              markers={communities}
              popup={({ marker: community }) => (
                <div>
                  <Link name="community-detail" community={community}>
                    {get(community, 'name')}
                  </Link>
                </div>
              )}
              pin={{
                iconUrl: '/images/icon-map-pin.svg',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

PlanCommunitiesMap.propTypes = {
  communities: PropTypes.arrayOf(PropTypes.object),
  activeMapPin: PropTypes.string,
};

PlanCommunitiesMap.defaultProps = {
  communities: [],
  activeMapPin: undefined,
};

export default (PlanCommunitiesMap);



// WEBPACK FOOTER //
// ./src/pages/PlanDetail/PlanCommunitiesMap.js